import type { MatchState } from '../State.js';
import { RELAY_HISTORY_SAMPLE_TICKS } from '../State.js';
import type { PlayerId } from '../ids.js';

// StatsSystem appends a relay-control sample every RELAY_HISTORY_SAMPLE_TICKS
// (every ~4 sim seconds at 50 ms ticks). The end-of-match summary reads the
// resulting series to render a relays-held sparkline per player without the UI
// having to compute anything itself (Rule 1).
//
// Squads-built and peak-income are NOT tracked here:
//   - squadsBuilt is incremented by ProductionSystem the tick a squad spawns.
//   - peakIncomePerSec is maintained on PlayerState by EconomySystem.
// This system only owns the time series.
//
// We deliberately let the series get one sample longer than would be strictly
// needed for the sparkline (≈120 samples in an 8-min match) — overhead is tiny
// and the test seam is simpler when the cadence is just `tick % N === 0`.
export function statsSystem(state: MatchState): void {
  if (state.tick % RELAY_HISTORY_SAMPLE_TICKS !== 0) return;
  state.stats.relayHistory.push({
    tick: state.tick,
    matchSeconds: state.matchSeconds,
    nodesByPlayer: [
      countNodesHeldBy(state, 0),
      countNodesHeldBy(state, 1),
    ],
  });
}

function countNodesHeldBy(state: MatchState, playerId: PlayerId): number {
  let n = 0;
  for (const node of Object.values(state.controlNodes)) {
    if (node.ownerId === playerId) n += 1;
  }
  return n;
}
